import type { NavigationScreenSiteTabCustomization } from '@gitbook/app-navigation';
import { Icon, type SVGIconComponent } from '@gitbook/spine-icons';

/**
 * Navigation items for the site customization screen.
 */
export const siteCustomizationTabs: ReadonlyArray<{
    id: NavigationScreenSiteTabCustomization['tab'];
    label: string;
    icon: SVGIconComponent;
}> = [
    {
        id: 'general',
        label: 'Theme',
        icon: Icon.Theme,
    },
    {
        id: 'layout',
        label: 'Layout',
        icon: Icon.Layout,
    },
    {
        id: 'ai',
        label: 'AI Assistant',
        icon: Icon.AIAgent,
    },
    {
        id: 'configure',
        label: 'Configure',
        icon: Icon.Options02,
    },
] as const;

/**
 * Resolve the site-space scope to use when navigating to a customization tab.
 */
export function getSiteCustomizationTabSiteSpaceId(
    tab: NavigationScreenSiteTabCustomization['tab'],
    siteSpaceId?: string
) {
    return tab === 'ai' ? undefined : siteSpaceId;
}
